export default __webpack_public_path__ + "static/media/pizza-project.6b807c26.png";